class ResponsiveSpritePlayer {
  /**
   * @param {HTMLElement} el
   * @param {Object} options
   * @param {number} options.cols - 列数
   * @param {number} options.rows - 行数
   * @param {number} options.fps - 帧率
   * @param {boolean} [options.loop=true]
   */
  constructor(el, { cols, rows, offsetX = 0, fps, loop = true }) {
    this.el = el;
    this.cols = cols;
    this.rows = rows;
    this.total = cols * rows;
    this.offsetX = offsetX;
    this.fps = fps;
    this.loop = loop;

    this.frame = 0;
    this.isPlaying = false;
    this.lastTime = 0;
    this.interval = 1000 / fps;
    this._raf = null;
    this.elWidth = this.el.clientWidth;
    this.elHeight = this.el.clientHeight;

    // 初始化
    this._updateBackgroundSize();
    window.addEventListener("resize", this._updateBackgroundSize.bind(this));
  }

  _updateBackgroundSize() {
    // 直接设百分比，让背景图被等分成 cols x rows
    this.elWidth = this.el.clientWidth;
    this.elHeight = this.el.clientHeight;
    this.el.style.backgroundSize = `${this.cols * this.elWidth}px ${this.rows * this.elHeight}px`;
  }

  start() {
    if (this.isPlaying) return;
    this.isPlaying = true;
    this.lastTime = performance.now();
    this._raf = requestAnimationFrame(this._update.bind(this));
  }

  stop() {
    this.isPlaying = false;
    cancelAnimationFrame(this._raf);
  }

  goto(frameIndex) {
    this.frame = Math.max(0, Math.min(frameIndex, this.total - 1));
    this._render();
  }

  _update(timestamp) {
    if (!this.isPlaying) return;

    const elapsed = timestamp - this.lastTime;
    if (elapsed >= this.interval) {
      this.frame++;
      if (this.frame >= this.total) {
        if (this.loop) this.frame = 0;
        else {
          this.stop();
          return;
        }
      }
      this._render();
      this.lastTime = timestamp;
    }

    this._raf = requestAnimationFrame(this._update.bind(this));
  }

  _render() {
    const col = this.frame % this.cols;
    const row = Math.floor(this.frame / this.cols);
    const _offsetX = this.offsetX * col;
    const x = col * this.elWidth + _offsetX;
    const y = row * this.elHeight;
    // 注意：background-position 用百分比更适配响应式
    this.el.style.backgroundPosition = `-${x}px -${y}px`;
  }
}

window.ResponsiveSpritePlayer = ResponsiveSpritePlayer;
